<template>
  <div class="indexTitle">
    <div>
      <span>{{titleText}}</span>
      <label></label>
    </div>
  </div>
</template>
<script>
   export default {
        name: 'IndexTitle',
        props:["titleText"],
        data() {
            return {
            }
        },
        created() {}
    }
</script>
<style scoped>
   .indexTitle{
     width: 1200px;
     margin: 40px auto;
     text-align: left;
   }
   .indexTitle span{
    display: block;
    width: 130px;
    height: 40px;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333;
    margin: 0 auto;
   }
   .indexTitle div{
     left: 0px;
     width: min-content;
     text-align: center;
   }
   @supports (-ms-ime-align: auto) { 
      .indexTitle div{
        width: 50px;
      }
    }
   .indexTitle label{
     display: block;
    width: 118px;
    height: 4px;
    background: #3370ff;
    border-radius: 2px;
    margin: 0 auto;
   }
</style>


// WEBPACK FOOTER //
// src/components/IndexTitle.vue